/**
 * Labstep
 *
 * @module prosemirror/components/NodeView/JupyterNotebook
 * @desc Renders an JupyterNotebook node
 */

import { JupyterNotebookItem } from 'labstep-web/components/JupyterNotebook/Item';
import { JupyterNotebook } from 'labstep-web/models/jupyter-notebook.model';
import { Read } from 'labstep-web/prosemirror/components/NodeView/Read';
import { useReactNodeView } from 'labstep-web/prosemirror/components/ReactNodeView';
import React from 'react';
import type { IJupyterNotebookNodeProps } from './types';

export class JupyterNotebookNode extends React.Component<
  IJupyterNotebookNodeProps,
  any
> {
  shouldComponentUpdate() {
    return Boolean(!this);
  }

  render() {
    const { id, timestamp } = this.props;
    return (
      <Read
        entityName={JupyterNotebook.entityName}
        id={id}
        timestamp={timestamp}
      >
        {({ entity: jupyterNotebook }) => (
          <JupyterNotebookItem
            jupyterNotebook={jupyterNotebook as any}
          />
        )}
      </Read>
    );
  }
}

export const JupyterNotebookNodeView = ({
  entity: experiment,
  timestamp,
}: any) => {
  const context = useReactNodeView();
  const { id, guid } = (context.node as any).attrs;
  return (
    <JupyterNotebookNode
      experiment={experiment}
      id={id || guid}
      timestamp={timestamp}
    />
  );
};
